import React from 'react';
import { useTranslation } from 'react-i18next';

import { CrossValidationError } from '../../__hooks/useCrossDateValidation';

import styles from './FallbackNoteContent.module.scss';

const FallbackNoteContent = ({ error }: { error: CrossValidationError }) => {
    const { t } = useTranslation();
    switch (error) {
        case CrossValidationError.MaxDurationExceeded:
            return (
                <>
                    <div className={styles.Headline}>
                        {t('TRANS-travel-duration-adjusted')}
                    </div>
                    <span className={styles.Text}>
                        {t('TRANS-exact-travel-duration-exceeds-travel-period')}
                    </span>
                </>
            );
    }
    return null;
};

export default FallbackNoteContent;
